import { create } from "zustand";

export interface MainStore {
  pdfSelectedUrl: string;
  selectedPdfId: number | null;
  setPdfSelectedUrl: (value: string) => void;
  setPdfSelectedId: (id: number | null) => void;
}

export const useMainStore = create<MainStore>((set) => ({
  pdfSelectedUrl: "",
  selectedPdfId: null,
  setPdfSelectedUrl: (value: string) => set({ pdfSelectedUrl: value }),
  setPdfSelectedId: (id: number | null) => set({ selectedPdfId: id }),
}));
